import { createContext, type ReactElement, type ReactNode, useContext } from 'react';

import type { ApiClient } from './api-client';

const ApiClientContext = createContext<ApiClient | null>(null);

/** Makes the {@link ApiClient} available to every screen. */
export function ApiClientProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}): ReactElement {
  return <ApiClientContext value={client}>{children}</ApiClientContext>;
}

/**
 * The API client of the running app.
 *
 * @throws {Error} when used outside `<ApiClientProvider>`: a wiring bug, not a runtime case.
 */
export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (client === null) throw new Error('useApiClient must be used inside <ApiClientProvider>');
  return client;
}
